import { useEffect } from 'react'
import { useWorkspaceColorScheme } from './useWorkspaceColorScheme'
import { useCurrentWorkspace } from './useCurrentWorkspace'
import { applyWhiteLabelColor, removeWhiteLabelColor } from 'utils/applyWhiteLabelColor'

export const useThemeProvider = () => {
  const { colorScheme } = useWorkspaceColorScheme()
  const workspace = useCurrentWorkspace()

  useEffect(() => {
    document.documentElement.removeAttribute('data-theme')
  }, [])

  document.documentElement.setAttribute('data-design-system', 'blaze')

  useEffect(() => {
    if (workspace?.is_whitelabel && workspace.white_label_color) {
      document.documentElement.setAttribute('data-color-scheme', 'whitelabel')
    } else if (colorScheme) {
      document.documentElement.setAttribute('data-color-scheme', colorScheme)
    } else {
      document.documentElement.removeAttribute('data-color-scheme')
    }
  }, [colorScheme, workspace?.is_whitelabel, workspace?.white_label_color])

  useEffect(() => {
    if (workspace?.is_whitelabel && workspace.white_label_color) {
      applyWhiteLabelColor(workspace.white_label_color)
    } else {
      removeWhiteLabelColor()
    }
  }, [workspace?.is_whitelabel, workspace?.white_label_color])
}
